import { render, staticRenderFns } from "./ModalSave.vue?vue&type=template&id=179150e7"
import script from "./ModalSave.vue?vue&type=script&lang=js"
export * from "./ModalSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports